import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../constants';

import GameList from '../components/GameList';

function GamesPage({ setGame }) {
    // Use the Navigate for redirection
    const redirect = useNavigate();

    // Use state to bring in the data
    const [games, setGames] = useState([]);

    // RETRIEVE the entire list of games
    const loadGames = async () => {
        const response = await fetch(`${BASE_URL}/games`);
        const games = await response.json();
        setGames(games);
    }


    // UPDATE a single game
    const onEditGame = async game => {
        setGame(game);
        redirect("/update");
    }


    // DELETE a single game  
    const onDeleteGame = async _id => {
        const response = await fetch(`${BASE_URL}/games/${_id}`, { method: 'DELETE' });
        if (response.status === 200) {
            const getResponse = await fetch(`${BASE_URL}/games`);
            const games = await getResponse.json();
            setGames(games);
        } else {
            console.error(`Error deleting game with ID: ${_id}. Status code: ${response.status}. Please try again.`);
        }
    }

    // LOAD all the games
    useEffect(() => {
        loadGames();
    }, []);

    // DISPLAY the games
    return (
        <>
            <h2>Atlanta Braves Game Log</h2>
            <p><p>Below is a list of all recorded games, including details about the
                stadium, Braves' score, and date of the game. You can edit or delete
                entries using the corresponding icons.</p>
            </p>
            <GameList
                games={games}
                onEdit={onEditGame}
                onDelete={onDeleteGame}
            />
        </>
    );
}

export default GamesPage;